import { render, staticRenderFns } from "./StaffGroupModal.vue?vue&type=template&id=84ffb412&scoped=true&"
import script from "./StaffGroupModal.vue?vue&type=script&lang=js&"
export * from "./StaffGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ffb412",
  null
  
)

export default component.exports